const a = "{{currentTime}} dari {{duration}}", n = "Hasil pencarian {{current}} dari {{total}}", t = "Hasil tidak ditemukan", s = "{{count}} hasil ditemukan", o = "{{count}} hasil ditemukan", A = 'Memutar dari $t(HOURS, { "count": {{hours}} }), $t(MINUTES, { "count": {{minutes}} }), dan $t(SECONDS, { "count": {{seconds}} }).', i = 'Memutar dari $t(MINUTES, { "count": {{minutes}} }) dan $t(SECONDS, { "count": {{seconds}} })', c = 'Memutar dari $t(SECONDS, { "count": {{seconds}} }).', T = "Kesalahan saat menyimpan perubahan pada transkrip.", E = "Baris transkrip di {{time}}. Konten adalah: {{text}}.", e = 'Wadah baris transkrip. Ada $t(TRANSCRIPT_LINES, { "count": {{count}} }) di dalam wadah ini. Untuk bernavigasi di dalam wadah ini, gunakan tombol panah.', _ = "Sedang menyimpan perubahan...", S = "Perubahan disimpan ke transkrip.", r = "Tombol perbarui caption sekarang tersedia.", u = "Tindakan", N = "Tambah anotasi di {{time}}", R = "Tambah pertanyaan di {{time}}", O = "Anotasi", I = "Auto", P = "Otomatis ({{quality}})", C = "Kembali", U = "Caption", d = "Bahasa Caption", m = "Kelola Caption", p = "Hapus {{language}}", L = "Ukuran Font", k = "Bahasa Caption: {{language}}", l = "{{language}} (otomatis)", D = "Kosongkan Pencarian", M = "Tutup", h = "Komentar", K = "Lanjutkan", G = "Kurangi Kecepatan Pemutaran", Y = "Kurangi Volume Suara sebesar {{percent}}%", g = "Panah Turun", b = "Tutup Editor Transkrip", B = "Perbarui Caption", H = "Kesalahan!", V = "Menyimpan...", y = "Disimpan!", F = "Edit Transkrip", W = "Teks tidak boleh kosong.", $ = "Layar penuh", J = "{{count}} jam", Q = "{{count}} jam", j = "Tambah Kecepatan Pemutaran", f = "Tambah Volume Suara sebesar {{percent}}%", v = "Inversikan Warna", x = "Lompat ke persentase spesifik (1-10%, 2-20%, dll)", Z = "Lompat ke Mulai", w = "Tindakan untuk {{title}}", X = "Pintasan Keyboard", q = "Bahasa", z = "Panah Kiri", aa = "Menu Utama", na = "{{count}} menit", ta = "{{count}} menit", sa = "Heningkan", oa = "Diheningkan", Aa = "Bahasa Caption Selanjutnya", ia = "Hasil pencarian berikutnya", ca = "Mati", Ta = "Di Bagian Atas", Ea = "Buka anotasi di {{time}}", ea = "Buka kuis yang selesai di {{time}}", _a = "Buka kuis di {{time}}", Sa = "Jeda", ra = "Putar", ua = "Kecepatan Pemutaran", Na = "Kecepatan Pemutaran: {{speed}}x", Ra = "Bahasa Caption Sebelumnya", Oa = "Hasil pencarian sebelumnya", Ia = "Kualitas", Pa = "Menu Kualitas", Ca = "Putar Ulang", Ua = "Atur Ulang Kecepatan Pemutaran", da = "Panah Kanan", ma = "Cari di transkrip", pa = "{{count}} detik", La = "{{count}} detik", ka = "Cari mundur: {{seconds}} detik", la = "Cari maju: {{seconds}} detik", Da = "Pengaturan", Ma = "Pintasan", ha = "Detail dan alat media", Ka = "Ruang", Ga = "Menu kecepatan pemutaran", Ya = "Mulai Gulir Otomatis", ga = "Alihkan Caption", ba = "Aktifkan Diheningkan", Ba = "Aktifkan Play/Pause", Ha = "adalah {{count}} baris transkrip", Va = "adalah {{count}} baris transkrip", ya = "Memuat transkrip...", Fa = "Kami tidak dapat memuat transkrip.", Wa = "Opsi Transkrip", $a = "Coba lagi", Ja = "Transkrip tidak tersedia", Qa = "Panah Atas", ja = "Pengaturan Video", fa = "Volume", va = "Volume: {{volume}}%", xa = {
  A11Y_DURATION: a,
  A11Y_SEARCH_HITS: n,
  A11Y_SEARCH_NO_RESULTS: t,
  A11Y_SEARCH_RESULTS_FOUND: s,
  A11Y_SEARCH_RESULTS_FOUND_other: o,
  A11Y_TIMESTAMP_JUMP_HOURS: A,
  A11Y_TIMESTAMP_JUMP_MINUTES: i,
  A11Y_TIMESTAMP_JUMP_SECONDS: c,
  A11Y_TRANSCRIPT_ERROR: T,
  A11Y_TRANSCRIPT_LINE: E,
  A11Y_TRANSCRIPT_LINES: e,
  A11Y_TRANSCRIPT_SAVING: _,
  A11Y_TRANSCRIPT_SUCCESS: S,
  A11Y_UPDATE_CAPTIONS_AVAILABLE: r,
  ACTION: u,
  ADD_ANNOTATION_AT: N,
  ADD_QUESTION_AT: R,
  ANNOTATIONS: O,
  AUTO: I,
  AUTO_QUALITY: P,
  BACK: C,
  CAPTIONS: U,
  CAPTIONS_LANGUAGE: d,
  CAPTIONS_MANAGE: m,
  CAPTION_DELETE: p,
  CAPTION_FONT_SIZE: L,
  CAPTION_LANGUAGE: k,
  CAPTION_LANGUAGE_AUTOMATIC: l,
  CLEAR_SEARCH: D,
  CLOSE: M,
  COMMENTS: h,
  CONTINUE: K,
  DECREASE_PLAYBACK_SPEED: G,
  DECREASE_VOLUME: Y,
  DOWN_ARROW: g,
  EDIT_CLOSE: b,
  EDIT_CONFIRM: B,
  EDIT_ERROR: H,
  EDIT_SAVING: V,
  EDIT_SUCCESS: y,
  EDIT_TRANSCRIPT: F,
  EDIT_VALIDATION_ERROR: W,
  FULLSCREEN: $,
  HOURS: J,
  HOURS_other: Q,
  INCREASE_PLAYBACK_SPEED: j,
  INCREASE_VOLUME: f,
  INVERT_COLORS: v,
  JUMP_TO_PERCENTAGE: x,
  JUMP_TO_START: Z,
  KEBAB_MENU: w,
  KEYBOARD_SHORTCUTS: X,
  LANGUAGE: q,
  LEFT_ARROW: z,
  MAIN_MENU: aa,
  MINUTES: na,
  MINUTES_other: ta,
  MUTE: sa,
  MUTED: oa,
  NEXT_CAPTION_LANGUAGE: Aa,
  NEXT_HIT: ia,
  OFF: ca,
  ON_TOP: Ta,
  OPEN_ANNOTATION_AT: Ea,
  OPEN_COMPLETED_QUIZ_AT: ea,
  OPEN_QUIZ_AT: _a,
  PAUSE: Sa,
  PLAY: ra,
  PLAYBACK_SPEED: ua,
  PLAYBACK_SPEED_MESSAGE: Na,
  PREVIOUS_CAPTION_LANGUAGE: Ra,
  PREVIOUS_HIT: Oa,
  QUALITY: Ia,
  QUALITY_MENU: Pa,
  REPLAY: Ca,
  RESET_PLAYBACK_SPEED: Ua,
  RIGHT_ARROW: da,
  SEARCH_TRANSCRIPT_PLACEHOLDER: ma,
  SECONDS: pa,
  SECONDS_other: La,
  SEEK_BACKWARD: ka,
  SEEK_FORWARD: la,
  SETTINGS: Da,
  SHORTCUT: Ma,
  SIDEBAR: ha,
  SPACE: Ka,
  SPEED_MENU: Ga,
  START_AUTOSCROLL: Ya,
  TOGGLE_CAPTIONS: ga,
  TOGGLE_MUTED: ba,
  TOGGLE_PLAY_PAUSE: Ba,
  TRANSCRIPT_LINES: Ha,
  TRANSCRIPT_LINES_other: Va,
  TRANSCRIPT_LOADING: ya,
  TRANSCRIPT_LOAD_ERROR: Fa,
  TRANSCRIPT_OPTIONS: Wa,
  TRANSCRIPT_RETRY: $a,
  TRANSCRIPT_UNAVAILABLE: Ja,
  UP_ARROW: Qa,
  VIDEO_SETTINGS: ja,
  VOLUME: fa,
  VOLUME_VALUE: va
};
export {
  a as A11Y_DURATION,
  n as A11Y_SEARCH_HITS,
  t as A11Y_SEARCH_NO_RESULTS,
  s as A11Y_SEARCH_RESULTS_FOUND,
  o as A11Y_SEARCH_RESULTS_FOUND_other,
  A as A11Y_TIMESTAMP_JUMP_HOURS,
  i as A11Y_TIMESTAMP_JUMP_MINUTES,
  c as A11Y_TIMESTAMP_JUMP_SECONDS,
  T as A11Y_TRANSCRIPT_ERROR,
  E as A11Y_TRANSCRIPT_LINE,
  e as A11Y_TRANSCRIPT_LINES,
  _ as A11Y_TRANSCRIPT_SAVING,
  S as A11Y_TRANSCRIPT_SUCCESS,
  r as A11Y_UPDATE_CAPTIONS_AVAILABLE,
  u as ACTION,
  N as ADD_ANNOTATION_AT,
  R as ADD_QUESTION_AT,
  O as ANNOTATIONS,
  I as AUTO,
  P as AUTO_QUALITY,
  C as BACK,
  U as CAPTIONS,
  d as CAPTIONS_LANGUAGE,
  m as CAPTIONS_MANAGE,
  p as CAPTION_DELETE,
  L as CAPTION_FONT_SIZE,
  k as CAPTION_LANGUAGE,
  l as CAPTION_LANGUAGE_AUTOMATIC,
  D as CLEAR_SEARCH,
  M as CLOSE,
  h as COMMENTS,
  K as CONTINUE,
  G as DECREASE_PLAYBACK_SPEED,
  Y as DECREASE_VOLUME,
  g as DOWN_ARROW,
  b as EDIT_CLOSE,
  B as EDIT_CONFIRM,
  H as EDIT_ERROR,
  V as EDIT_SAVING,
  y as EDIT_SUCCESS,
  F as EDIT_TRANSCRIPT,
  W as EDIT_VALIDATION_ERROR,
  $ as FULLSCREEN,
  J as HOURS,
  Q as HOURS_other,
  j as INCREASE_PLAYBACK_SPEED,
  f as INCREASE_VOLUME,
  v as INVERT_COLORS,
  x as JUMP_TO_PERCENTAGE,
  Z as JUMP_TO_START,
  w as KEBAB_MENU,
  X as KEYBOARD_SHORTCUTS,
  q as LANGUAGE,
  z as LEFT_ARROW,
  aa as MAIN_MENU,
  na as MINUTES,
  ta as MINUTES_other,
  sa as MUTE,
  oa as MUTED,
  Aa as NEXT_CAPTION_LANGUAGE,
  ia as NEXT_HIT,
  ca as OFF,
  Ta as ON_TOP,
  Ea as OPEN_ANNOTATION_AT,
  ea as OPEN_COMPLETED_QUIZ_AT,
  _a as OPEN_QUIZ_AT,
  Sa as PAUSE,
  ra as PLAY,
  ua as PLAYBACK_SPEED,
  Na as PLAYBACK_SPEED_MESSAGE,
  Ra as PREVIOUS_CAPTION_LANGUAGE,
  Oa as PREVIOUS_HIT,
  Ia as QUALITY,
  Pa as QUALITY_MENU,
  Ca as REPLAY,
  Ua as RESET_PLAYBACK_SPEED,
  da as RIGHT_ARROW,
  ma as SEARCH_TRANSCRIPT_PLACEHOLDER,
  pa as SECONDS,
  La as SECONDS_other,
  ka as SEEK_BACKWARD,
  la as SEEK_FORWARD,
  Da as SETTINGS,
  Ma as SHORTCUT,
  ha as SIDEBAR,
  Ka as SPACE,
  Ga as SPEED_MENU,
  Ya as START_AUTOSCROLL,
  ga as TOGGLE_CAPTIONS,
  ba as TOGGLE_MUTED,
  Ba as TOGGLE_PLAY_PAUSE,
  Ha as TRANSCRIPT_LINES,
  Va as TRANSCRIPT_LINES_other,
  ya as TRANSCRIPT_LOADING,
  Fa as TRANSCRIPT_LOAD_ERROR,
  Wa as TRANSCRIPT_OPTIONS,
  $a as TRANSCRIPT_RETRY,
  Ja as TRANSCRIPT_UNAVAILABLE,
  Qa as UP_ARROW,
  ja as VIDEO_SETTINGS,
  fa as VOLUME,
  va as VOLUME_VALUE,
  xa as default
};
